module.exports = __webpack_public_path__ + "static/media/html5.9636ea5f.svg";